import { DeltaServerChangeFeed } from "@hds-products/delta-server-client";
import { EventEngineStateClientEntity } from "../index.mjs";

class EventEngineStateClientChangeFeed extends DeltaServerChangeFeed {
    static DEFAULT_PROJECTION = {};
    constructor(deltaServerClient, baseUri, customHeaderFn, projection = EventEngineStateClientChangeFeed.DEFAULT_PROJECTION) {
        super(EventEngineStateClientEntity, deltaServerClient, baseUri, EventEngineStateClientEntity.prototype._meta.entityName, customHeaderFn, projection);
    }
}
export { EventEngineStateClientChangeFeed };
export default EventEngineStateClientChangeFeed;